import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { CompanyClientResponse } from "../types/api.types";
import Dropdown from "./Dropdown";

interface IChangeCompany {
  selectedCompany?: CompanyClientResponse | null;
  showModal: boolean;
  setShowModal: (newShowModal: boolean) => void;
  companyOptions: CompanyClientResponse[];
  onCompanyChange?: (clientId: string) => void;
  onSubmitProp: (data: CompanyFormData) => void;
}

interface CompanyFormData {
  company: string;
}

const ChangeCompanyModal: React.FC<IChangeCompany> = ({
  selectedCompany,
  setShowModal,
  showModal,
  companyOptions,
  onCompanyChange,
  onSubmitProp,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<CompanyFormData>({
    defaultValues: {
      company: companyOptions[0]?.clientID || "",
    },
  });

  const onSubmit = (data: CompanyFormData) => {
    onSubmitProp(data);
    if (onCompanyChange) {
      onCompanyChange(data.company);
    }
    setShowModal(false);
  };

  useEffect(() => {
    if (selectedCompany) {
      setValue("company", selectedCompany.clientID);
    }
  }, [selectedCompany]);

  return (
    <Dialog
      open={showModal}
      onClose={() => setShowModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      fullWidth
      maxWidth="xs"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle id="modal-modal-title">Cambiar empresa</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Controller
            name="company"
            control={control}
            rules={{ required: "La empresa es requerida" }}
            render={({ field }) => (
              <Dropdown
                label="Empresa"
                field={field}
                searchable
                searchPlaceholder="Buscar empresa..."
                options={companyOptions?.map((company) => ({
                  id: company.clientID,
                  label: company.comercialName,
                }))}
                error={errors.company?.message}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowModal(false)}>Cancelar</Button>
          <Button type="submit" variant="contained" color="primary">
            Cambiar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ChangeCompanyModal;
